export default __webpack_public_path__ + "static/media/1858.be620d12.png";